import { Circle, Loader2 } from "lucide-react";
import {
  filterOnlineWorkspaceMembers,
  getWorkspacePresenceDisplayName,
  getWorkspacePresenceRoleLabel,
} from "@/lib/workspacePresence";
import { workspaceUserDisplayName } from "@/modules/despacho/despachoWorkspaceAuxiliaries";

/**
 * Fila compacta «En línea:» con todos los miembros activos del workspace.
 */
export default function WorkspaceOnlineBadges({
  presenceItems = [],
  teamUsers = [],
  currentUserId = "",
  loading = false,
  testIdPrefix = "workspace-online",
  emptyLabel = "Nadie conectado en este momento.",
}) {
  const teamById = new Map((teamUsers || []).map((row) => [row.id, row]));
  const onlineMembers = filterOnlineWorkspaceMembers(presenceItems).map((row) => {
    const team = teamById.get(row.id);
    const baseName = team ? workspaceUserDisplayName(team) : getWorkspacePresenceDisplayName(row);
    const suffix = row.id === currentUserId ? " (tú)" : "";
    return {
      ...row,
      label: `${baseName}${suffix}`,
      role: getWorkspacePresenceRoleLabel(row),
    };
  });

  return (
    <div
      className="flex flex-wrap items-center gap-1.5 text-[10px]"
      data-testid={`${testIdPrefix}-strip`}
    >
      <span className="font-semibold text-[#0F2D5C] shrink-0">En línea:</span>
      {loading ? (
        <span className="text-slate-500 inline-flex items-center gap-1">
          <Loader2 className="w-3 h-3 animate-spin" aria-hidden />
          Consultando…
        </span>
      ) : onlineMembers.length === 0 ? (
        <span className="text-slate-500" data-testid={`${testIdPrefix}-empty`}>
          {emptyLabel}
        </span>
      ) : (
        onlineMembers.map((row) => (
          <span
            key={row.id}
            className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[10px] text-emerald-900"
            data-testid={`${testIdPrefix}-badge-${row.id}`}
            title={row.role}
          >
            <Circle className="w-2 h-2 fill-emerald-500 text-emerald-500 shrink-0" aria-hidden />
            {row.label}
          </span>
        ))
      )}
    </div>
  );
}
